/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect } from 'react';
import { useTimer } from 'react-timer-hook';

export interface ITimerProps {
  timeout: number;
  onEnd?: () => void;
  restartTrigger?: string;
  shouldOnlyShowSeconds?: boolean;
}

const Timer: FC<ITimerProps> = ({
  timeout,
  onEnd,
  restartTrigger,
  shouldOnlyShowSeconds = false,
}) => {
  const { seconds, minutes, restart } = useTimer({
    autoStart: false,
    expiryTimestamp: new Date(),
    onExpire: onEnd,
  });

  useEffect(() => {
    const expiryTimestamp = new Date();
    expiryTimestamp.setSeconds(expiryTimestamp.getSeconds() + timeout);
    restart(expiryTimestamp);
  }, [timeout, restartTrigger]);

  return (
    <>
      {shouldOnlyShowSeconds ? (
        `${seconds}`.padStart(2, '0')
      ) : (
        <>
          {`${minutes}`.padStart(2, '0')}:{`${seconds}`.padStart(2, '0')}
        </>
      )}
    </>
  );
};

export default Timer;
